import api from './client'
import type { MerchantMaintenanceEquipmentResponse, MerchantMaintenanceFeaturePayload, MerchantMaintenanceProfilePayload, MerchantMaintenanceProfileResponse, MerchantMaintenanceProgrammingPayload, MerchantMaintenanceStatusResponse, MerchantMaintenanceUpdateResponse } from '../api'

export const merchantMaintenanceApi = {
  getProfile: async (merchantId: string): Promise<MerchantMaintenanceProfileResponse> => {
    const response = await api.get<MerchantMaintenanceProfileResponse>(`/merchants/${merchantId}/maintenance/profile`)
    return response.data
  },

  updateProfile: async (
    merchantId: string,
    payload: MerchantMaintenanceProfilePayload,
  ): Promise<MerchantMaintenanceUpdateResponse> => {
    const response = await api.patch<MerchantMaintenanceUpdateResponse>(`/merchants/${merchantId}/maintenance/profile`, payload)
    return response.data
  },

  checkRequestStatus: async (
    merchantId: string,
    requestId: string,
  ): Promise<MerchantMaintenanceStatusResponse> => {
    const response = await api.get<MerchantMaintenanceStatusResponse>(`/merchants/${merchantId}/maintenance/requests/${requestId}/status`)
    return response.data
  },

  listEquipment: async (merchantId: string): Promise<MerchantMaintenanceEquipmentResponse> => {
    const response = await api.get<MerchantMaintenanceEquipmentResponse>(`/merchants/${merchantId}/maintenance/equipment`)
    return response.data
  },

  updateEquipmentFeature: async (
    merchantId: string,
    terminalId: string,
    payload: MerchantMaintenanceFeaturePayload,
  ): Promise<MerchantMaintenanceUpdateResponse> => {
    const response = await api.patch<MerchantMaintenanceUpdateResponse>(
      `/merchants/${merchantId}/maintenance/equipment/${terminalId}/feature`,
      payload,
    )
    return response.data
  },

  updateEquipmentProgramming: async (
    merchantId: string,
    terminalId: string,
    payload: MerchantMaintenanceProgrammingPayload,
  ): Promise<MerchantMaintenanceUpdateResponse> => {
    const response = await api.patch<MerchantMaintenanceUpdateResponse>(
      `/merchants/${merchantId}/maintenance/equipment/${terminalId}/programming`,
      payload,
    )
    return response.data
  },
}
